import { render, staticRenderFns } from "./SettingsComponent.vue?vue&type=template&id=07d30755&scoped=true"
import script from "./SettingsComponent.vue?vue&type=script&lang=js"
export * from "./SettingsComponent.vue?vue&type=script&lang=js"
import style0 from "./SettingsComponent.vue?vue&type=style&index=0&id=07d30755&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d30755",
  null
  
)

export default component.exports